import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import type { HTMLAttributes } from 'vue';
    import { cn } from '@/lib/utils';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'TableHead',
  props: {
    class: {}
  },
  setup(__props: any) {

    const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("th", {
    "data-slot": "table-head",
    class: _normalizeClass(
            _unref(cn)(
                'sticky z-20 h-10 bg-white px-2 text-left align-middle text-xs font-semibold whitespace-nowrap first:rounded-tl last:rounded-tr [&:has([role=checkbox])]:pr-0 [&>[role=checkbox]]:translate-y-[2px]',
                props.class,
            )
        )
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 2))
}
}

})